import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { emptyTeam, Team } from "../../../../interfaces/team";
import { getTeamSingle, updateTeam } from "../../../../services/team";
import { getClubOptions } from "../../../../services/club";
import { Modality } from "../../../../interfaces/modality";
import { Category } from "../../../../interfaces/category";
import { getModalityOptions } from "../../../../services/modality";
import { getCategoryOptions } from "../../../../services/category";
import { Club } from "../../../../interfaces/club";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminTeamEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminTeamEdit(props: AdminTeamEditProps) {
    const [clubsLoaded, setClubsLoaded] = useState(false);
    const [modalitiesLoaded, setModalitiesLoaded] = useState(false);
    const [categoriessLoaded, setCategoriesLoaded] = useState(false);
    const [teamLoaded, setTeamLoaded] = useState(false);
    const [team, setTeam] = useState<Team>(emptyTeam);
    const [clubs, setClubs] = useState<Club[]>([]);
    const [modalities, setModalities] = useState<Modality[]>([]);
    const [categories, setCategories] = useState<Category[]>([]);

    useEffect(() => {
        getClubOptions()
            .then(response => {
                setClubs(response.data);
                setClubsLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
        
        getModalityOptions()
            .then(response => {
                setModalities(response.data);
                setModalitiesLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
        
        getCategoryOptions()
            .then(response => {
                setCategories(response.data);
                setCategoriesLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });

        getTeamSingle(props.id)
            .then(response => {
                setTeam(response.data);
                setTeamLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            club_id: event.target.club_id.value,
            modality_id: event.target.modality_id.value,
            category_id: event.target.category_id.value
        }
        updateTeam(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }
    
    return (
        <Modal className="admin-team-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_team") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { !(teamLoaded && clubsLoaded && modalitiesLoaded && categoriessLoaded) && 
                    <LoadingSpinner />
                }
                { (teamLoaded && clubsLoaded && modalitiesLoaded && categoriessLoaded) && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group controlId="id">
                                <Form.Control type="hidden" name="id" required 
                                    defaultValue={ team.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ team.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="club_id">
                                <Form.Label aria-required="true">{ t("club") }</Form.Label>
                                <Form.Select aria-label={ t("club") } required defaultValue={ team.club_id }>
                                    <option value="">{ t("select_club") }</option>
                                    { clubs.map((c: Club) => {
                                        return <option key={ 'club-' + c.id } value={ c.id }>{ c.name }</option>;
                                    })}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="modality_id">
                                <Form.Label>{ t("modality") }</Form.Label>
                                <Form.Select aria-label={ t("modality") } defaultValue={ team.modality_id ?? "" }>
                                    <option value="">{ t("select_modality") }</option>
                                    { modalities.map((m: Modality) => {
                                        return <option key={ 'modality-' + m.id } value={ m.id }>{ m.name }</option>;
                                    })}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="category_id">
                                <Form.Label>{ t("category") }</Form.Label>
                                <Form.Select aria-label={ t("category") } defaultValue={ team.category_id ?? "" }>
                                    <option value="">{ t("select_category") }</option>
                                    { categories.map((c: Category) => {
                                        return <option key={ 'category-' + c.id } value={ c.id }>{ c.name }</option>;
                                    })}
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
